document.addEventListener("DOMContentLoaded", () => {
  const currentPath = window.location.pathname;
  const redirectBase = "https://www.zeedog.eu";

  // Função para verificar se a URL deve ser excluída do redirecionamento
  const isExcludedPath = (path) => {
    return path.startsWith("/account") || path.startsWith("/checkout");
  };

  // Função para detectar a linguagem no path
  const detectLang = (path) => {
    if (path.startsWith("/it")) return "/it";
    if (path.startsWith("/es")) return "/es";
    return null; // nenhuma linguagem detectada
  };

  if (!isExcludedPath(currentPath)) {
    const lang = detectLang(currentPath) || "/"; // padrão: /
    const redirectUrl = `${redirectBase}${lang}`;

    // Redirecionar somente se já não estivermos na URL correta
    if (!window.location.href.startsWith(redirectUrl)) {
      window.location.href = redirectUrl;
    }
  }
});
